import React, {FC, useMemo, useState} from 'react';

import Map from '@geomatico/geocomponents/Map/Map';

/****** START OF COG SETUP ******/
import maplibregl, {StyleSpecification} from 'maplibre-gl';
import {cogProtocol} from '@geomatico/maplibre-cog-protocol';

maplibregl.addProtocol('cog', cogProtocol);

import mlcontour from 'maplibre-contour';
import {MAPSTYLES} from '../../config';

const demSource = new mlcontour.DemSource({
  url: 'https://tilemaps.icgc.cat/tileserver/tileserver.php/terreny_icgc_2m_rgb/{z}/{x}/{y}.png',
  encoding: 'mapbox', // "mapbox" or "terrarium" default="terrarium"
  maxzoom: 17,
  worker: true, // offload isoline computation to a web worker to reduce jank
  cacheSize: 100, // number of most-recent tiles to cache
  timeoutMs: 10_000, // timeout on fetch requests
});
demSource.setupMaplibre(maplibregl);

const sources: StyleSpecification['sources'] = {
  'contour-source': {
    type: 'vector',
    tiles: [
      demSource.contourProtocolUrl({
        thresholds: {
          // zoom: [minor, major]
          11: [200, 1000],
          12: [100, 500],
          14: [50, 200],
          15: [20, 100],
          16: [10, 50],
        },
        // optional, override vector tile parameters:
        contourLayer: 'contours',
        elevationKey: 'ele',
        levelKey: 'level',
        extent: 4096,
        buffer: 1,
      }),
    ],
    maxzoom: 16,
  }
};


const layers: StyleSpecification['layers'] = [{
  id: 'contour-lines',
  type: 'line',
  source: 'contour-source',
  'source-layer': 'contours',
  paint: {
    'line-color': 'rgba(0,0,0, 50%)',
    // level = highest index in thresholds array the elevation is a multiple of
    'line-width': ['match', ['get', 'level'], 1, 1, 0.5],
  },
}, {
  id: 'contour-labels',
  type: 'symbol',
  source: 'contour-source',
  'source-layer': 'contours',
  filter: ['>', ['get', 'level'], 0],
  layout: {
    'symbol-placement': 'line',
    'text-size': 10,
    'text-field': ['concat', ['number-format', ['get', 'ele'], {}], '\''],
    'text-font': ['Noto Sans Bold'],
  },
  paint: {
    'text-halo-color': 'white',
    'text-halo-width': 1,
  },
}];

/****** END OF COG SETUP ******/


export type MainContentProps = {
  mapStyle: string
};

const INITIAL_VIEWPORT = {
  latitude: 42.502312,
  longitude: 0.990829,
  zoom: 15,
  bearing: 0,
  pitch: 0
};

const MainContent: FC<MainContentProps> = () => {
  const [viewport, setViewport] = useState(INITIAL_VIEWPORT);

  const mapStyle = useMemo(() => MAPSTYLES.find(mapstyle => mapstyle.label === 'Gris')?.id, []);

  return <Map
    mapLib={maplibregl}
    mapStyle={mapStyle}
    viewport={viewport}
    onViewportChange={setViewport}
    sources={sources}
    layers={layers}
  />;
};

export default MainContent;
